<div class="pdf-page app-aul-007-24" id="aul00724">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>SERVICE OF SUIT CLAUSE</b>
  </p>
  <br />
  <div class="font-small">
    <p>
      It is understood and agreed that in the event of the failure of the
      Company to pay any amount claimed to be due hereunder, the Company, at the
      request of the Named Insured, will submit to the jurisdiction of a court
      of competent jurisdiction within the United States of America. The
      foregoing shall not constitute a waiver of the right of the Company to
      remove, remand or transfer such suit to any other court of competent
      jurisdiction in accordance with the applicable statutes of the state or
      United States pertinent hereto.
    </p>
    <p>
      In any suit instituted against them upon this contract, the Company will
      abide by the final decision of such court or of any appellate court in the
      event of an appeal.
    </p>
    <p>
      It is further agreed that service of process in such suit may be made upon
      the Superintendent, Commissioner, or Director of Insurance or other person
      specified for that purpose in the statute or his successor or successors
      in office as their true and lawful attorney upon whom may be served any
      lawful process in any action, suit, or proceeding instituted by or on
      behalf of the Named Insured or any beneficiary hereunder arising out of
      this contract of insurance.
    </p>
    <br />
    <p>
      It is further agreed that service of process in such suit may be made upon
      the Company directly at:
    </p>
    <p class="mb-0" style="text-align: center">
      <b>Fortegra Specialty Insurance Company</b>
    </p>
    <p style="text-align: center">
      Attn: Corporate Creations Registered Agent Offices
    </p>
    <br />
    <p class="mb-0" style="text-align: center">
      <b><i>For address and phone number by state see: </i></b>
    </p>
    <p class="link" style="text-align: center">
      https://www.corporatecreations.us/RAoffices/
    </p>
  </div>
</div>
